import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export interface ConsentWarningProps {
  expiryDate: string;
  variant?: 'access' | 'share';
  durationMonths?: number;
}
export function ConsentWarning({
  expiryDate,
  variant = 'access',
  durationMonths = 24
}: ConsentWarningProps) {
  // Calculate date 12 months from now
  const futureDate = new Date();
  futureDate.setMonth(futureDate.getMonth() + 12);
  const formattedDate = futureDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).replace(/\//g, '/');
  const message = variant === 'access' ? `We will access your data until` : `We will share your data for ${durationMonths} months from today until`;
  return <div className="flex items-start space-x-3 p-4 bg-[#4DB8C4]/10 rounded-xl border-2 border-[#4DB8C4]/30" data-id="element-1628">
      <ShieldCheckIcon className="w-5 h-5 text-[#1e3a5f] flex-shrink-0 mt-0.5" data-id="element-1629" />
      <p className="text-sm text-gray-700 leading-relaxed" data-id="element-1630">
        {message}{' '}
        <span className="font-bold text-gray-900" data-id="element-1631">{formattedDate}</span>
      </p>
    </div>;
}